<template>
  <div :class="classes" class="winners-2021-place-winners-card">
    <div
      v-if="$slots.winners"
      class="winners-2021-place-winners-card__winners-block"
    >
      <slot name="winners" />
    </div>
    <Winners2021PlaceChip v-if="$slots.title">
      <slot name="title" />
    </Winners2021PlaceChip>
    <Winners2021PlaceWinnersCardSubtitle>
      Награды
    </Winners2021PlaceWinnersCardSubtitle>
    <div class="winners-2021-place-winners-card__prizes">
      <div class="winners-2021-place-winners-card__prizes-list-wrapper">
        <Winners2021PlaceWinnersCardPrizeList :list="prizes" />
      </div>
      <div class="winners-2021-place-winners-card__prizes-desc">
        <span v-for="(prize, index) in prizes" :key="index">
          <a :href="prize.hfer" target="_blank" rel="noopener">{{
            prize.name
          }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Winners2021PlaceWinnersCardPrizeList from "./Winners2021PlaceWinnersCardPrizeList";
import Winners2021PlaceWinnersCardSubtitle from "./Winners2021PlaceWinnersCardSubtitle";
import Winners2021PlaceChip from "./Winners2021PlaceChip";

export default {
  name: "Winners2021PlaceWinnersCard",
  components: {
    Winners2021PlaceWinnersCardPrizeList,
    Winners2021PlaceWinnersCardSubtitle,
    Winners2021PlaceChip
  },
  props: {
    winners: {
      type: Array,
      default: () => []
    },
    prizes: {
      type: Array,
      default: () => []
    },
    growPrizes: Boolean,
    growWinners: Boolean
  },
  computed: {
    classes() {
      return {
        "winners-2021-place-winners-card_grow-prizes": this.growPrizes,
        "winners-2021-place-winners-card_grow-winners": this.growWinners
      };
    }
  }
};
</script>

<style lang="scss">
.winners-2021-place-winners-card {
  $p: &;

  text-align: center;
  background: linear-gradient(to bottom, rgba(#171a29, 0.8), rgba(#1d3063, 1));
  border-radius: 6px;
  font-family: "Montserrat";
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 35px 40px;

  height: 100%;

  &__prizes {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  &__prizes-list-wrapper {
    margin: 0 -20px 15px;
    display: flex;
    align-items: center;
  }

  .winners-2021-place-chip {
    height: 42px;
    width: 158px;
    position: relative;
    z-index: 1;
    margin-bottom: 35px;
  }

  &__winners-block {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &__prizes-desc {
    font-size: 13px;
    text-align: left;
    min-height: 1.5 * 13px * 4;
    line-height: 1.5;
    letter-spacing: 0.01em;
    a {
      color: #fff;
      font-weight: 300;
      display: inline;

      &:hover {
        text-decoration: underline;
      }
    }

    span:not(:last-of-type)::after {
      content: ", ";
    }
  }

  &_grow-prizes {
    #{$p}__prizes {
      flex-grow: 1;
    }
    #{$p}__prizes-list-wrapper {
      flex-grow: 1;
    }
  }

  &_grow-winners {
    #{$p}__winners-block {
      flex-grow: 1;
    }
  }

  @include breakpoint("md-and-down") {
    &__prizes-desc {
      min-height: 0;
    }
  }

  @include breakpoint("xs-only") {
    padding: 30px 15px 20px;

    &__prizes-desc {
      font-size: 12px;
    }
  }
}
</style>
